module.exports = "<dbm-edit class=\"admin-edit\" [withoutButton]=\"!isAdmin\" (save)=\"save()\" (cancel)=\"cancel()\">\n    <div class=\"admin-window\">\n        <div class=\"admin-container\" *ngIf=\"additionalOption\">\n            <dbm-additional-options-proprties [items]=\"additionalOption\" [totalItemsPerRow]=\"2\"\n                                    [isOpenEditMode]=\"isAdmin\"></dbm-additional-options-proprties>\n        </div>\n    </div>\n</dbm-edit>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/admin/properties/properties.component.html
// module id = 1721
// module chunks = 0